<template>
  <v-card width="100%" flat>
    <!--  오브젝트 페이지 타이틀 START -->
    <v-card-title primary-title class="justify-left">
      <span :class="styles.objectTitle"
        ><strong
          >{{ formObject.objectType == "QUESTION" ? "Q. " : ""
          }}{{ formObject.objectTitle }}</strong
        ></span
      >
    </v-card-title>
    <!-- 시작 페이지 타이틀 END -->
    <v-divider></v-divider>
    <!-- 시작 페이지 설명 START -->
    <v-card-text>
      <pre class="form-object-text-content mb-2">{{
        formObject.objectDescription
      }}</pre>
      <v-row v-if="formObject.attachment">
        <v-col :align="objectMediaProp ? objectMediaProp.align : 'center'">
          <v-img :src="formObject.attachment.filePathUri" width="300"></v-img>
        </v-col>
      </v-row>
      <v-row v-if="formObject.objectType == 'VIDEO'">
        <v-col :align="objectMediaProp ? objectMediaProp.align : 'center'">
          <iframe
            class="form-object-video-content"
            title="video-content"
            :width="objectMediaProp.width"
            :height="objectMediaProp.height"
            :src="`${objectMediaProp.src}?controls=0&disablekb=1&showinfo=0`"
          >
          </iframe>
        </v-col>
      </v-row>
      <v-row v-if="formObject.objectType == 'QUESTION'">
        <v-col>
          <!-- 기존 답변은 responseAnswer로 전달하고, 변경된 입력값은 questionAnswer로 수신 -->
          <component
            :is="questionCompoment"
            :question="formObject.question"
            :responseAnswer="responseAnswer"
            @input="questionAnswer = $event"
            :isValid.sync="isValid"
            ref="question"
            :themeColor="themeColor"
          ></component>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- 시작 페이지 설명 END -->
  </v-card>
</template>

<script>
import {} from "@/redsurvey/api/survey";
export default {
  props: {
    formObject: {
      type: Object,
      required: true,
    },
    formFormat: {
      type: String,
      required: true,
    },
    objectValues: {
      type: Object,
    },
    responseAnswers: {
      type: Array,
      default: () => [],
    },
    themeColor: {
      type: String,
      default: "primary"
    }
  },
  computed: {
    questionCompoment() {
      switch (this.formObject.question.questionType) {
        case "SINGLE_TEXT": // 주관식: 단답형
          return () =>
            import(
              "@/redsurvey/components/survey/objects/question/RsQuestionSingleText.vue"
            );
        case "MULTI_TEXT": // 주관식: 서술형
          return () =>
            import(
              "@/redsurvey/components/survey/objects/question/RsQuestionMultiText.vue"
            );
        case "SINGLE_SELECT": // 객관식: 단일선택
          return () =>
            import(
              "@/redsurvey/components/survey/objects/question/RsQuestionSingleSelect.vue"
            );
        case "MULTI_SELECT": // 객관식: 복수선택
          return () =>
            import(
              "@/redsurvey/components/survey/objects/question/RsQuestionMultiSelect.vue"
            );
        case "DROP_DOWN": // 객관식: 드롭다운
          return () =>
            import(
              "@/redsurvey/components/survey/objects/question/RsQuestionDropdown.vue"
            );
        case "SINGLE_SCALE": // 척도: 단일 척도
          return () =>
            import(
              "@/redsurvey/components/survey/objects/question/RsQuestionSingleScale.vue"
            );
        case "MATRIX_RADIO": // 척도: 단일 선택 매트릭스
          return () =>
            import(
              "@/redsurvey/components/survey/objects/question/RsQuestionMatrixRadio.vue"
            );
        case "MATRIX_CHECK": // 척도: 복수 선택 매트릭스
          return () =>
            import(
              "@/redsurvey/components/survey/objects/question/RsQuestionMatrixCheck.vue"
            );
        // case "FILE_UPLOAD":
        //   break;
        default:
          return null;
      }
    },
    objectMediaProp() {
      return JSON.parse(this.formObject.mediaProp);
    },
    responseAnswer() {
      // 현재 폼 객체에 해당하는 기존 답변만 골라 문항 컴포넌트에 전달
      return {
        response: (this.responseAnswers || []).filter(
          (answer) => answer.formObjectId == this.formObject.formObjectId,
        ),
      };
    },
    styles() {
      switch (this.$vuetify.breakpoint.name) {
        case "sm":
          return {
            pageTitle: "text-h6",
            objectTitle: "text-subtitle-1",
            description:
              "text-subtitle-1 content-description mx-5 form-object-text-content",
          };
        default:
          return {
            pageTitle: "text-h5",
            objectTitle: "text-h6",
            description:
              "text-subtitle-1 content-description mx-5 form-object-text-content",
          };
      }
    },
    nextPage() {
      // 해당 오브젝트의 폼 오브젝트 및 문항 답변에 따른 nextPage값 취득
      let nextPage = null;
      if (
        this.formObject.objectType == "QUESTION" &&
        (this.formObject.question.questionType == "SINGLE_SELECT" ||
          this.formObject.question.questionType == "DROP_DOWN" ||
          this.formObject.question.questionType == "SINGLE_SCALE") &&
        this.questionAnswer
      ) {
        this.formObject.question.questionOpts.forEach((qo) => {
          if (
            this.questionAnswer.questionAnswerVals.some(
              (qa) => qa == qo.questionOptId
            )
          ) {
            nextPage = qo.nextPage;
          }
        });
        // TODO: 문항 유형의 폼인 경우
      if(this.formFormat == "STEP_BY_QUESTION") {
        // 결괏값이 미설정[NOT_SET]인 경우 오브젝트 기본설정 값 페이지로 처리함.
        if (nextPage == null || nextPage == "NOT_SET") {
          nextPage = this.formObject.nextPage;
        }
      }
      }
      // }

      return nextPage;
    },
  },
  data() {
    return {
      questionAnswer: null,
      isValid: false,
    };
  },
  methods: {
    init() {
      switch (this.formObject.objectType) {
        case "TEXT":
        case "IMAGE":
        case "VIDEO":
          this.questionAnswer = null;
          break;
        default:
          break;
      }
      // 검증 초기값 설정
      if (this.formObject.question && this.formObject.question.required) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }

      this.emitObjectValue();
    },
    emitObjectValue() {
      const val = {
        formObjectId: this.formObject.formObjectId,
        objectType: this.formObject.objectType,
        values: this.questionAnswer,
        isRequired: this.formObject.question
          ? this.formObject.question.required
          : false,
        validOpts: this.formObject.question
          ? JSON.parse(this.formObject.question.validationOptions)
          : null,
        isValid: this.isValid,
        nextPage: this.nextPage,
      };
      this.$emit("update:objectValues", val);
    },
    checkValidation() {
      this.$refs.question.checkValidation();
    },
  },
  watch: {
    questionAnswer() {
      this.emitObjectValue();
    },
    isValid() {
      this.emitObjectValue();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.form-object-video-content {
  border: 0px;
}
.form-object-text-content {
  // line-break: auto;
  white-space: pre-wrap;
}
</style>